// Diagnostic correlation only: never use this ID for authentication or deduplication.
export const createApiRequestId = () => {
  try {
    if (typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
  } catch (_error) {
    // Older/restricted browsers still need to be able to send the request.
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    return (character === "x" ? random : (random & 3) | 8).toString(16);
  });
};

// Fetch accepts objects, Headers and entry arrays. Preserve their actual values.
export const normalizeRequestHeaders = (headers) => {
  if (!headers) return {};
  if (Array.isArray(headers)) return Object.fromEntries(headers);
  if (typeof headers.entries === "function") return Object.fromEntries(headers.entries());
  return headers;
};

export const buildApiRequestHeaders = (headers, requestId) => {
  const result = {};
  for (const [key, value] of Object.entries(normalizeRequestHeaders(headers))) {
    const lower = key.toLowerCase();
    if (lower === "x-ll-reqid") continue;
    // Header names are case insensitive; a caller override must not append a
    // second Authorization value to the SDK credential.
    const prior = Object.keys(result).find((name) => name.toLowerCase() === lower);
    if (prior) delete result[prior];
    result[key] = value;
  }
  // A direct service URL can omit this header to preserve its CORS contract.
  if (requestId) result["x-ll-reqid"] = requestId;
  return result;
};
